export const HTTP_REQUEST_STARTED = 'HTTP_REQUEST_STARTED';
export const requestStarted = (name) => ({ type: HTTP_REQUEST_STARTED, name });

export const HTTP_REQUEST_ERROR = 'HTTP_REQUEST_ERROR';
export const requestError = (name) => ({ type: HTTP_REQUEST_ERROR, name });

export const HTTP_REQUEST_COMPLETED = 'HTTP_REQUEST_COMPLETED';
export const requestComplete = (name) => ({ type: HTTP_REQUEST_COMPLETED, name });
